import React from 'react';

import SectionMessage from '@atlaskit/section-message';

const ExtensionConfig = () => {
  return (
    <div style={{ padding: '5rem 20% 0 20%' }}>
      <SectionMessage>
        You have successfully configured the Jira Integration.
        Log into Jira to edit workflow configurations.
        You can <a target="_blank" rel="noopener noreferrer" href="https://support.pagerduty.com/docs/jira-server">click here</a> to learn more about this integration.
      </SectionMessage>
    </div>
  );
};

export default ExtensionConfig;
